@if (modalService.visible()) {
  <div class="modal-overlay" (click)="onOverlayClick()" [attr.data-testid]="tid('overlay')">
    <div class="modal-box" (click)="onModalClick($event)" role="dialog" aria-modal="true" [attr.data-testid]="tid('box')">

      <div class="modal-center-icon" aria-hidden="true">
        <svg
          class="close-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="2" />
          <path
            d="M8 8L16 16M16 8L8 16"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <p class="modal-text" [attr.data-testid]="tid('text')">{{ modalService.text() }}</p>

      <button type="button" class="modal-button" (click)="onButtonClick()" [attr.data-testid]="tid('button-accept')">
        {{ modalService.buttonLabel() }}
      </button>

    </div>
  </div>
}